export const REGISTER_SUCCESS = "user/register_success";
export const REGISTER_FAIL = "user/register_fail"

export const LOGIN_SUCCESS = "user/login_success";
export const LOGIN_FAIL = 'user/login_fail';

export const LOGOUT = 'user/logout';

export const GET_USER_SUCCESS = "user/get_user_success";
export const GET_USER_FAIL = "user/get_user_fail";

export const UPDATE_USER_SUCCESS ="user/update_user_success";
export const UPDATE_USER_FAIL ="user/update_user_fail";

export const DELETE_USER_SUCCESS = "user/delete_user_success";
export const DELETE_USER_FAIL = "user/delete_user_fail";

export const CHANGE_PASSWORD_SUCCESS = "user/change_password_success"; 
export const CHANGE_PASSWORD_FAIL = "user/change_password_fail"; 
